$(document).ready(function() {

  $(window).on('scroll',function() {
    if (0 < $(this).scrollTop()) {
      $('body').addClass('fix');
      $('.melon-header-transparent').removeClass('transparent');
    }
    else {
      $('body').removeClass('fix');
      $('.melon-header-transparent').addClass('transparent');
    }
  });

  $(window).scroll(function(){ 
		var topCurrent = $(document).scrollTop();
		var subMenuPos = $('.kpop-content').offset().top;
    var headerHeight = $('#header').height();
    var eventTarget = $(".sub-menu");
    if(topCurrent > subMenuPos - headerHeight){
			eventTarget.addClass("fix");
		} else {
			eventTarget.removeClass("fix");
		}
  });

  $(window).scroll(function(){ 
		var topCurrent = $(document).scrollTop();
    var posBgY = topCurrent/2;
    var eventTarget = $(".kpop-cont .bg-interaction");
    eventTarget.css('background-position-y', posBgY + 'px');
  });

  $('.board-rank .list-rank').slick({
    autoplay: true,
    arrows: false,
    vertical: true,
    draggable: false,
    swipe: false,
    pauseOnHover: false
  })

  $('.chart-opened .list-chart').slick({
    slidesToScroll: 1,
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    variableWidth: true,
    arrows: false,
    draggable: false,
    swipe: false,
    pauseOnHover: false,
    cssEase: 'linear',
  });

  $('.kpop-detail .list-detail').on('init', function(event, slick) {
    $('.kpop-detail .list-detail').find('.slick-current').removeClass('slick-current').addClass('reset-animation');
    setTimeout( function() {
        $('.kpop-detail .list-detail').find('.reset-animation').removeClass('reset-animation').addClass('slick-current');
    }, 1);
  });

  $('.kpop-detail .list-detail').slick({
    initialSlide: 0,
    infinite: false,
    lazyLoad: 'ondemand',
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    focusOnChange: false,
    accessibility: false,
    centerPadding: '10.4%',
    adaptiveHeight: true
  });

  $('.kpop-detail .list-detail').on('afterChange', function(event, slick, currentSlide){
    $('.slick-list').height($('.kpop-detail .slick-current .detail-content').innerHeight());
    $(slick.$slides).removeClass('slick-prev');
  });

  $('.kpop-detail .list-detail').on('beforeChange', function(event, slick, currentSlide){
    $(slick.$slides[currentSlide]).addClass('slick-prev');
  });

  $.fn.contentActive = function(translatePos) {
    var topCurrent = $(document).scrollTop();
    var target = this
    var targetPos = this.offset().top;
    var targetTranslatePos = 0;
    var winHeight = $(window).height();

    translatePos === undefined ? targetTranslatePos = 0 : targetTranslatePos = translatePos;

    $(window).resize(function() {
      winHeight = $(window).height();
    })
    if(topCurrent > targetPos - winHeight - targetTranslatePos){
      target.addClass("active")
    }
    $(window).scroll(function(){ 
      var topCurrent = $(document).scrollTop();
      if(topCurrent > targetPos - winHeight - targetTranslatePos){
        target.addClass("active")
      } else {
        target.removeClass("active")
      }
    })
  }

  $(".tab-menu").each(function() {
    $(this).contentActive()
  })
  $(".chart-year").each(function() {
    $(this).contentActive(100)
  })
  $(".chart-year .list-music li").each(function() {
    $(this).contentActive(100)
  })
  $(".chart-open").each(function() {
    $(this).contentActive()
  })
  $(".event-banner").each(function() {
    $(this).contentActive()
  })
  $(".masterpiece-banner").each(function() {
    $(this).contentActive(100)
  })
  $(".board-rank").each(function() {
    $(this).contentActive()
  })
  $(".chart-rank .list-music li").each(function() {
    $(this).contentActive(100)
  })
  $(".chart-special").each(function() {
    $(this).contentActive()
  })
  $(".chart-special .list-special li").each(function() {
    $(this).contentActive(100)
  })
  $(".chart-special-large .item-rankup").each(function() {
    $(this).contentActive(100)
  })

  $(".info-review .txt-review").on("click", function() {
    $(this).closest('.music-content').find('.btn-more-review').toggleClass('open');
    $(this).closest('.info-review').toggleClass('open');
    $('.slick-list').height($(this).closest('.detail-content').innerHeight());
  })
  $(".btn-more-review").on("click", function() {
    $(this).toggleClass('open');
    $(this).siblings('.info-music').children('.info-review').toggleClass('open');
     $('.slick-list').height($(this).closest('.detail-content').innerHeight());
  })
});